import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

// Robust utility to detect strict desktop/laptop (not mobile/tablet, not touch device)
// function isStrictDesktopDevice() {
//   const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
//   const isMobileUA = mobileRegex.test(navigator.userAgent);
//   const hasTouch =
//     "ontouchstart" in window ||
//     (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
//     (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0);
//   return !isMobileUA && !hasTouch;
// }

function triggerGoogleTranslate(langCode) {
  const select = document.querySelector("select.goog-te-combo");
  if (select) {
    select.value = langCode;
    select.dispatchEvent(new Event("change"));
    try {
      localStorage.setItem("selectedLanguage", langCode);
    } catch (e) {}
  } else {
    alert("Language widget not loaded yet. Please try again in a moment.");
  }
}

function Navbar() {
  const canHover =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const [publicUserLoggedIn, setPublicUserLoggedIn] = useState(!!localStorage.getItem("token"));

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      setPublicUserLoggedIn(!!token);
    };
    checkToken();

    const handleStorage = (e) => {
      if (e.key === "token") {
        setPublicUserLoggedIn(!!e.newValue);
      }
    };

    window.addEventListener("storage", handleStorage);
    const handleTokenChange = () => checkToken();
    window.addEventListener("tokenChanged", handleTokenChange);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("tokenChanged", handleTokenChange);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true" || false;
  });

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.style.setProperty("--bg-primary", "#0f172a");
      document.documentElement.style.setProperty("--bg-secondary", "#1a1a2e");
      document.documentElement.style.setProperty("--text-primary", "#f1f5f9");
      document.documentElement.style.setProperty("--text-secondary", "#cbd5e1");
      document.documentElement.style.setProperty("--border-color", "rgba(255, 255, 255, 0.1)");
      document.documentElement.style.setProperty("--accent-color", "#60a5fa");
      document.body.classList.add("dark-mode");
      localStorage.setItem("darkMode", "true");
    } else {
      document.documentElement.style.setProperty("--bg-primary", "#ffffff");
      document.documentElement.style.setProperty("--bg-secondary", "#f8f9fa");
      document.documentElement.style.setProperty("--text-primary", "#1f2937");
      document.documentElement.style.setProperty("--text-secondary", "#475569");
      document.documentElement.style.setProperty("--border-color", "rgba(0, 0, 0, 0.06)");
      document.documentElement.style.setProperty("--accent-color", "#3b82f6");
      document.body.classList.remove("dark-mode");
      localStorage.setItem("darkMode", "false");
    }
    window.dispatchEvent(new Event("darkModeChanged"));
  }, [isDarkMode]);

  const closeMenu = () => setIsOpen(false);
  const closeDropdown = () => setIsDropdownOpen(false);

  const indianLanguages = [
    { code: "hi", label: "हिन्दी (Hindi)" },
    { code: "en", label: "English" },
    { code: "bn", label: "বাংলা (Bengali)" },
    { code: "te", label: "తెలుగు (Telugu)" },
    { code: "mr", label: "मराठी (Marathi)" },
    { code: "ta", label: "தமிழ் (Tamil)" },
    { code: "ur", label: "اردو (Urdu)" },
    { code: "gu", label: "ગુજરાતી (Gujarati)" },
    { code: "kn", label: "ಕನ್ನಡ (Kannada)" },
    { code: "or", label: "ଓଡ଼ିଆ (Odia)" },
    { code: "pa", label: "ਪੰਜਾਬੀ (Punjabi)" },
    { code: "ml", label: "മലയാളം (Malayalam)" },
    { code: "as", label: "অসমীয়া (Assamese)" },
    { code: "mai", label: "मैथिली (Maithili)" },
    { code: "sat", label: "ᱥᱟᱱᱛᱟᱲᱤ (Santali)" },
    { code: "ks", label: "کٲشُر (Kashmiri)" },
    { code: "ne", label: "नेपाली (Nepali)" },
    { code: "kok", label: "कोंकणी (Konkani)" },
    { code: "sd", label: "سنڌي (Sindhi)" },
    { code: "doi", label: "डोगरी (Dogri)" },
    { code: "mni", label: "মৈতৈলোন (Manipuri)" },
    { code: "bodo", label: "बर’ (Bodo)" },
    { code: "sa", label: "संस्कृत (Sanskrit)" },
  ];

  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const closeLangDropdown = () => setLangDropdownOpen(false);

  return (
    <>
      {isOpen && (
        <div
          className="sidebar-backdrop"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.18)",
            zIndex: 1000,
            transition: "background 0.2s",
          }}
          onClick={closeMenu}
          onTouchStart={closeMenu}
        />
      )}

      <nav className="navbar">
        <div className="navbar-top">
          <div className="logo">
            <h1>
              <a href="https://www.jobfind24.shop">JOBFIND24</a>
            </h1>
            <h3>
              <a href="https://www.jobfind24.shop">www.jobfind24.shop</a>
            </h3>
          </div>
        </div>

        <div className="navbar-bottom">
          {/* Language dropdown: works on mobile + desktop */}
          <div
            className={`language-dropdown${langDropdownOpen ? " open" : ""}`}
            tabIndex={0}
            // onBlur={closeLangDropdown}
            onMouseEnter={canHover ? () => setLangDropdownOpen(true) : undefined}
            onMouseLeave={canHover ? closeLangDropdown : undefined}
            style={{ position: "relative" }}
          >
            <button
              type="button"
              className="language-dropdown-toggle"
              title="Change Language"
              onClick={() => setLangDropdownOpen((prev) => !prev)}
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#9A3B3B",
                display: "flex",
                alignItems: "center",
                gap: "2px",
                padding: "0 10px",
              }}
            >
              <span style={{ fontSize: "1.3em" }}>A</span>/<span style={{ fontSize: "1.3em" }}>अ</span> ▾
            </button>

            {langDropdownOpen && (
              <ul className="language-dropdown-menu">
                {indianLanguages.map((lang) => (
                  <li key={lang.code}>
                    <button
                      type="button"
                      // onClick={() => {
                      onPointerDown={(e) =>{
                        e.preventDefault();
                        triggerGoogleTranslate(lang.code);
                        closeLangDropdown();
                        if (/Mobi|Android/i.test(navigator.userAgent)) {
                          setTimeout(() => window.location.reload(), 700);
                        }
                      }}
                    >
                      {lang.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <ul className={isOpen ? "nav-links open" : "nav-links"}>
            {publicUserLoggedIn ? (
              <li className="more-mobile">
                <Link to="/publicuser/publicpage" onClick={closeMenu}>
                  User Profile
                </Link>
              </li>
            ) : (
              <li className="more-mobile">
                <Link to="/publicuser/login" onClick={closeMenu}>
                  Login
                </Link>
              </li>
            )}

            <li>
              <Link to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/jobTablePage" onClick={closeMenu}>
                Latest Job
              </Link>
            </li>
            <li>
              <Link to="/admitCardTablePage" onClick={closeMenu}>
                Admit Card
              </Link>
            </li>
            <li>
              <Link to="/resultTablePage" onClick={closeMenu}>
                Result
              </Link>
            </li>
            <li>
              <Link to="/searchPage" onClick={closeMenu}>
                Search
              </Link>
            </li>

            {/* More dropdown: click/tap works on mobile too */}
            <li
              className="dropdown more-desktop"
              onMouseEnter={canHover ? () => setIsDropdownOpen(true) : undefined}
              onMouseLeave={canHover ? closeDropdown : undefined}
            >
              <button
                type="button"
                className="dropdown-toggle"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
                aria-expanded={isDropdownOpen}
              >
                More ▾
              </button>

              {isDropdownOpen && (
                <ul className="dropdown-menu">
                  <li className="dropdown-row">
                    <Link to="/contactPage" onClick={() => { closeMenu(); closeDropdown(); }}>
                      Contact Us
                    </Link>
                  </li>
                  <li className="dropdown-row">
                    <Link to="/aboutPage" onClick={() => { closeMenu(); closeDropdown(); }}>
                      About Us
                    </Link>
                  </li>
                  <li className="dropdown-row">
                    <Link to="/answerKeyTablePage" onClick={() => { closeMenu(); closeDropdown(); }}>
                      Answer Key
                    </Link>
                  </li>
                  <li className="dropdown-row">
                    <Link to="/syllabusTablePage" onClick={() => { closeMenu(); closeDropdown(); }}>
                      Syllabus
                    </Link>
                  </li>
                  <li className="dropdown-row">
                    <Link to="/admissionTablePage" onClick={() => { closeMenu(); closeDropdown(); }}>
                      Admission
                    </Link>
                  </li>
                  <li className="dropdown-row">
                    <Link to="/tool" onClick={() => { closeMenu(); closeDropdown(); }}>
                      Tools
                    </Link>
                  </li>
                  <li style={{ borderTop: "1px solid #444", marginTop: 4 }}></li>
                  {publicUserLoggedIn ? (
                    <li className="dropdown-row">
                      <Link to="/publicuser/publicpage" onClick={() => { closeMenu(); closeDropdown(); }}>
                        User Profile
                      </Link>
                    </li>
                  ) : (
                    <li className="dropdown-row">
                      <Link to="/publicuser/login" onClick={() => { closeMenu(); closeDropdown(); }}>
                        Login
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </li>

            <li className="more-mobile">
              <Link to="/contactPage" onClick={closeMenu}>
                Contact Us
              </Link>
            </li>
            <li className="more-mobile">
              <Link to="/aboutPage" onClick={closeMenu}>
                About Us
              </Link>
            </li>
            <li className="more-mobile">
              <Link to="/answerKeyTablePage" onClick={closeMenu}>
                Answer Key
              </Link>
            </li>
            <li className="more-mobile">
              <Link to="/syllabusTablePage" onClick={closeMenu}>
                Syllabus
              </Link>
            </li>
            <li className="more-mobile">
              <Link to="/admissionTablePage" onClick={closeMenu}>
                Admission
              </Link>
            </li>
            <li className="more-mobile">
              <Link to="/tool" onClick={closeMenu}>
                Tools
              </Link>
            </li>
          </ul>

          <div className="navbar-actions">
            <button
              className="theme-toggle"
              onClick={() => setIsDarkMode(!isDarkMode)}
              title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              {isDarkMode ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="5"></circle>
                  <line x1="12" y1="1" x2="12" y2="3"></line>
                  <line x1="12" y1="21" x2="12" y2="23"></line>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                  <line x1="1" y1="12" x2="3" y2="12"></line>
                  <line x1="21" y1="12" x2="23" y2="12"></line>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                </svg>
              )}
            </button>

            <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={() => setIsOpen(!isOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;